import Table from "ui/components/Table";
import { Column } from "react-table";
import colors from "core/resources/theme/colors";




interface TableAccordionProps {
    data?: any
    columns: Column[];

}




function TableAccordion({ data, columns }: TableAccordionProps) {
    

    return (<>
        <Table<any>
            styles={{ boxShadow: "none", color: colors.black, fontWeight: 700, textAlign: "start" }}
            columns={[...columns]}

            data={{
                items: data.parcelas as any[],
                meta: {
                    currentPage: 0,
                    itemCount: 0,
                    itemsPerPage: data!.length ?? 0,
                    totalItems: data!.length ?? 0,
                    totalPages: 1,
                },
            }}
        />
    </>);
}
export default TableAccordion;